import { Box, ContentBlock, Loader, Stack } from 'braid-design-system';

export const LoadingBlock = () => (
  <Box background="surface">
    <ContentBlock>
      <Box paddingY={['xlarge', 'xxlarge']}>
        <Stack space="xlarge" align="center">
          <Loader data={{ testid: 'loading-block' }} />
        </Stack>
      </Box>
    </ContentBlock>
  </Box>
);
